module.exports = __webpack_public_path__ + "static/media/platform-image.d6d6935e.svg";